
<template>
  <div class=" mb-0" style="margin-top: 20%;">
            <div
              v-for="(audio, indexo) in audios.slice(index, index + 1)"
              :key="indexo"
              class=""
            >
              <div class="m-auto relative md:mt-24 mt-8">
                <img
                  class="md:w-10/12 lg:h-96 w-full md:h-72 h-52 rounded-md block m-auto  object-cover"
                  :src="getImage(artist,audio)"
                  alt="Album Pic"
                />
              </div>
              <div class="mt-3">
                <h3 class="text-xl text-gray-100 text-center font-semibold">
                  {{ artist ? artist.name_ar : audio.artist.name_ar }}
                </h3>
                <h3 class="text-xl text-gray-100 text-center font-semibold">
                  {{ audio.name_ar }}
                </h3>
              </div>
            </div>
          </div>
</template>

<script>
export default {
  props: ["audios", "artist", "index"],
data() {
  return {
    https: "https://systech-abrof.s3.amazonaws.com/artists/",
  };
},
methods: {
  getImage(artist,audio) {
      var images;
      if(audio&& audio.artist&&audio.artist.cover){
        return this.https + audio.artist.cover;
     
      }else if (artist.cover) {
        return this.https + artist.cover;
      } else {
         images = require.context("@/assets/logo", false, /\.svg$/);
        return images("./" + "main.svg");
      }
    },
},

}
</script>

<style>

</style>